import React,{useState,useEffect} from 'react';
import { useHistory } from "react-router-dom";
import { useStore } from 'react-redux';
import RoutineList from 'components/containers/routine/RoutineList'
import ModalText from 'components/modal/ModalText'
import Bottom_Modal_var3 from 'components/modal/Bottom_Modal_var3'
import serverController from "server/serverController";

import { Routineinner } from './style';

export default function RoutineListLayout({match}) {
    const history = useHistory();
    const store = useStore();

    const [modalOption ,setModalOption] = useState("");
    const [textModalShow,setTextModalShow] = useState(false);
    const [modalShow,setModalShow] = useState(false);

    const [currentPostIndex , setCurrentPostIndex] = useState(0);
    // 페이지 이동
    const [screenIndex ,setScreenIndex] = useState(0);

    //모달창들
    const clickSelector =  {
        "routine" : [
            () => {setModalShow(false); setModalOption("");},
            () => {delSubmit();setModalShow(false); setModalOption("");},
        ],
    };
    
    useEffect(()=>{
        if(modalOption === "routinetxt" ){
            setTextModalShow(true);
        }
        else if(modalOption != "")
            setModalShow(true);
        
    },[modalOption]);

    
    const [routineInfo ,setRoutineInfo] = useState([]);
    const updateNext = (index) =>{
        // 페이지 더 생성되면 숫자 늘려나가기
        if(screenIndex + index === -1 || screenIndex + index > 2)
            return;
        setScreenIndex(screenIndex + index);
    }
    const infoCallBack=(res)=>{
        if(res.success === 1){
            setRoutineInfo(res.data.routines);
        }
        else
        {
            let state = store.getState();
            let errState = state['errorStateInfo'];
            let errFlag = errState['fetchErrTriggerd'];

            if(!errFlag && res['error'] && res['error']['res_data'])
            {
                let errData = res['error']['res_data'];
                if(errData['detail_code'] === 'LOGIN_REQ')
                {        
                    alert("로그인이 필요합니다.");
                    history.replace('/social')
                }
                else
                {
                    alert("예기치 못한 오류가 발생하였습니다."); 
                }
            }
        }
      }
    
    //페이지가 렌더링이 되었을 때 한번 호출
    useEffect(() => {
        serverController.getServerData(`tasks/routines`,infoCallBack);
    },[]);

    
    


    //루틴 삭제
    const delCallBack  = (res) =>{
        if(res.success === 1){
            let deletedItem = res['data']['deleted_item'][0];
            setRoutineInfo(routineInfo.filter(item=>item.no !== deletedItem['no']));
        } else {
            let state = store.getState();
            let errState = state['errorStateInfo'];
            let errFlag = errState['fetchErrTriggerd'];

            if(!errFlag && res['error'] && res['error']['res_data'])
            {
                let errData = res['error']['res_data'];
                if(errData['detail_code'] === 'LOGIN_REQ')
                {        
                    alert("로그인이 필요합니다.");
                    history.replace('/social')
                }
                else if (errData['detail_code'] === 'ROUTINE_DOES_NOT_EXIST') 
                {
                    alert("해당 루틴이 존재하지 않습니다.");
                }
                else
                {
                    alert("예기치 못한 오류가 발생하였습니다.");
                }
            }
        }
    }
    const delSubmit =()=>{
        let data = {};
          serverController.updateFileDeleteFetchController(`tasks/routines/${currentPostIndex}`,JSON.stringify(data),delCallBack);
    }


    return (
        <Routineinner>
            <RoutineList 
                updateNext={updateNext} 
                setModalOption={setModalOption}
                setTextModalShow={setTextModalShow}
                routineInfo={routineInfo}
                setCurrentPostIndex={setCurrentPostIndex}
            />

            <Bottom_Modal_var3 
                modalShow={modalShow}    //모달 보여지는 여부
                setModalShow={setModalShow} 
                modalOption={modalOption}
                clickEventList={clickSelector[modalOption]}
                currentPostIndex={currentPostIndex}
                setModalOption={setModalOption}
            />
            <ModalText 
                setTextModalShow={setTextModalShow}
                textModalShow={textModalShow}
                modalOption={modalOption}
                />
        </Routineinner>
    )
}
